import {
  LoginActionT,
  LoginFailureActionT,
  LoginPayloadT,
  LogoutActionT,
  LogoutPayloadT,
  SwitchOrganizationPayloadT,
  UnstablePreventApplicationFromRenderingActionT,
} from '../../types'

export const LOGOUT = '@@SWA/LOGOUT' as const
export const LOGIN = '@@SWA/LOGIN' as const
export const UNSTABLE_PREVENT_APPLICATION_FROM_RENDERING =
  '@@SWA/UNSTABLE_PREVENT_APPLICATION_FROM_RENDERING' as const
export const LOGIN_FAILURE = '@@SWA/LOGIN_FAILURE' as const
export const SWITCH_ORGANIZATION = '@@SWA/SWITCH_ORGANIZATION' as const

export const logout = (payload?: LogoutPayloadT): LogoutActionT => ({
  type: LOGOUT,
  payload,
})

export const login = (payload: LoginPayloadT): LoginActionT => ({
  type: LOGIN,
  payload,
})

export const unstablePreventApplicationFromRendering =
  (): UnstablePreventApplicationFromRenderingActionT => ({
    type: UNSTABLE_PREVENT_APPLICATION_FROM_RENDERING,
  })

export const loginFailure = (): LoginFailureActionT => ({
  type: LOGIN_FAILURE,
})

export const switchOrganization = (payload: SwitchOrganizationPayloadT) => ({
  type: SWITCH_ORGANIZATION,
  payload,
})
